import authReducer from "./auth";
import ciReducer from "./ci";

export default Object.assign(
  {},
  {
    auth: authReducer,
    ci: ciReducer,
  }
);
